import React from "react";
import { Select, Col } from "antd";
import {
  FormItem,
  InputItem,
  InputNumberItem,
  DatePickerItem,
  SwitchItem,
  SelectItem,
  SelectInsumosItem,
  SelectEmpleadosItem,
  SelectPedidosItem,
} from "./Items";
import SelectClientesItem from "./SelectClientesItem";
import SelectProyectosItem from "./SelectProyectosItem";
import SelectSubProyectosItem from "./SelectSubProyectosItem";
import SelectCanalVentaItem from "./SelectCanalVentaItem";
import SelectUsuarioItem from "./SelectUsuarioItem";

const { Option } = Select;

export const SELECTORES_REFERENCIA = {
  cliente: SelectClientesItem,
  proyecto: SelectProyectosItem,
  subProyecto: SelectSubProyectosItem,
  insumo: SelectInsumosItem,
  empleado: SelectEmpleadosItem,
  usuario: SelectUsuarioItem,
  pedido: SelectPedidosItem,
  canalVenta: SelectCanalVentaItem,
};

export const renderCampoOrdenProduccionPU = (campo, { empresaId, headersToken } = {}) => {
  const esBooleano = campo.tipo === "booleano";
  const comunes = {
    name: campo.key,
    label: campo.etiqueta,
    required: campo.obligatorio,
    margin: true,
    ...(esBooleano ? { specialLayoutSwitch: true, valuePropName: "checked" } : { labelCol: { span: 24 }, wrapperCol: { span: 24 } }),
  };

  const campoRenderizado = (() => {
    switch (campo.tipo) {
      case "numero":
        return (
          <FormItem {...comunes}>
            <InputNumberItem style={{ width: "100%" }} placeholder={campo.etiqueta} />
          </FormItem>
        );
      case "fecha":
        return (
          <FormItem {...comunes}>
            <DatePickerItem style={{ width: "100%" }} placeholder={campo.etiqueta} />
          </FormItem>
        );
      case "booleano":
        return (
          <FormItem {...comunes}>
            <SwitchItem />
          </FormItem>
        );
      case "seleccion":
        return (
          <FormItem {...comunes}>
            <SelectItem placeholder={campo.etiqueta} allowClear>
              {(campo.opciones || []).map((opcion) => (
                <Option key={opcion.valor} value={opcion.valor}>
                  {opcion.etiqueta}
                </Option>
              ))}
            </SelectItem>
          </FormItem>
        );
      case "referencia": {
        const SelectorReferencia = SELECTORES_REFERENCIA[campo.entidadReferencia];
        if (SelectorReferencia) {
          return (
            <FormItem {...comunes}>
              <SelectorReferencia empresaId={empresaId} headersToken={headersToken} placeholder={campo.etiqueta} />
            </FormItem>
          );
        }
        return (
          <FormItem {...comunes}>
            <InputItem placeholder={campo.etiqueta} />
          </FormItem>
        );
      }
      default:
        return (
          <FormItem {...comunes}>
            <InputItem placeholder={campo.etiqueta} />
          </FormItem>
        );
    }
  })();

  return (
    <Col span={8} xs={24} sm={12} lg={8} key={campo.key}>
      {campoRenderizado}
    </Col>
  );
};
